import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
	roles: string[]; // Array of roles that can access the route
	element: React.ReactNode; // The component to render
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles, element }) => {
	const auth = JSON.parse(localStorage.getItem('AUTH') || '{}'); // Parse the auth object from localStorage
	const userRole = auth.role || 'customer'; // Get the role from the parsed object or default to 'customer'

	console.log(userRole);

	if (roles.includes(userRole)) {
		return <>{element}</>;
	} else {
		return <Navigate to='/auth-pages/login' />; // Redirect to login or another page if unauthorized
	}
};

export default ProtectedRoute;
